OT.createNS('OT.Search.Helpers.DateUtilities');

OT.Search.Helpers.DateUtilities = (function() {

    var getMomentDateTimeFromStrings = function(date, time) {

        time = OT.Search.Helpers.convertTimeTo24Hour(time);

        var dateTime = date.replace(/\//g, '-') + ' ' + time;
        var dateFormat = "YYYY-MM-DD HH:mm";

        return moment(dateTime, dateFormat);
    };

    var formatDateTimeStringsToIsoDateFormat = function(date, time) {
        var dateTime = getMomentDateTimeFromStrings(date, time);
        return dateTime.format('YYYY-MM-DD HH:mm');
    };

    var formatDateTimeStringsToUnixTimestamp = function(date, time) {
        var dateTime = getMomentDateTimeFromStrings(date, time);
        return dateTime.format('x');
    };

    var roundToNextHalfHour = function(time) {
        var actualMinutes = time.minutes();
        if (actualMinutes > 30) {
            return time.add('hours', 1).minutes(0);
        }
        return time.minutes(30);
    };

    return {
        formatDateTimeStringsToIsoDateFormat: formatDateTimeStringsToIsoDateFormat,
        formatDateTimeStringsToUnixTimestamp: formatDateTimeStringsToUnixTimestamp,
        getDateTimeFromString: getMomentDateTimeFromStrings,
        roundToNextHalfHour: roundToNextHalfHour
    };

})();
